import type { ReactNode } from 'react';
import { Icon, icons } from './Icon';
import Loader from './Loader';

type Props = {
  children: ReactNode;
  isLoading?: boolean;
};

/**
 *  Produces a macOS-like "window" to display the attribution report in.
 */
const AttributionWindow = ({ children, isLoading }: Props) => (
  <div className="modal-attribution-preview">
    <div className="modal-attribution-preview-header">
      <Icon icon={icons.circle} />
      <Icon icon={icons.circle} />
      <Icon icon={icons.circle} />
    </div>
    <div className="attribution-frame-container">
      {isLoading && (<Loader />)}
      {children}
    </div>
  </div>
);

export default AttributionWindow;
